
import React from "react";
import type { Note } from "./activityUtils";

interface NoteEntryProps {
  date: string;
  content: string;
}

const NoteEntryComponent: React.FC<NoteEntryProps> = ({ date, content }) => {
  return (
    <div className="border-l-2 border-white/20 pl-4">
      <p className="text-white/70 text-sm">{new Date(date).toLocaleDateString()}</p>
      <p className="text-white mt-1">{content}</p>
    </div>
  );
};

// Memoize as note entries don't change once rendered
export const NoteEntry = React.memo(NoteEntryComponent);
